import styled from '@emotion/styled';

export const FieldSet = styled.div`
  border: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
